import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
export function NotifyModal(_param) {
    var hTitle = _param.hTitle, msgText = _param.msgText, props = _object_without_properties(_param, [
        "hTitle",
        "msgText"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var heightM = rest.heightM || 0;
    var handleChange = function(e) {};
    var handleClick = function() {};
    var handleClose = function() {
        return props.onHide();
    };
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: hTitle && hTitle != "" ? hTitle : "หัวข้อความแจ้งเตือน"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pt-4 text-break",
                    style: {
                        fontSize: "22px",
                        color: "#2F4858",
                        overflowY: "auto",
                        height: heightM && heightM > 0 ? heightM : 300
                    },
                    dangerouslySetInnerHTML: {
                        __html: msgText && msgText != "" ? msgText : "ข้อความแจ้งเตือน"
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Footer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "outline-secondary",
                    onClick: handleClose,
                    children: "ยืนยัน"
                })
            })
        ]
    }));
}
